import ActionTypes from "../../enums/ActionTypes"
import { createAPIRequestReducer } from "../api"

export default createAPIRequestReducer(ActionTypes.USERS_CHANGE_PASSWORD)

